import React from "react";

const WeatherCard = ({ weatherData, city, state }) => {
  const temperature =
    weatherData.temperature != null
      ? Math.round(weatherData.temperature)
      : null;
  const minTemp =
    weatherData.forecast?.temperature_2m_min?.[0] != null
      ? Math.round(weatherData.forecast.temperature_2m_min[0])
      : null;
  const date =
    weatherData.date != null
      ? new Date(weatherData.date).toLocaleDateString("en-US", {
          weekday: "long",
          month: "long",
          day: "numeric",
        })
      : null;
  return (
    <div className="w-full text-gray-800 p-6 rounded-2xl">
      <div className="grid">
        <h1 className="text-3xl font-semibold mb-2">
          {city}, {state}
        </h1>
        <p className="text-xl font-medium">{date}</p>
        <p>
          <span className="text-[120px] font-bold leading-none text-[#456ec1]">
            {temperature}°{weatherData.temperatureUnit === "fahrenheit" ? "F" : "C"}
          </span>
          {minTemp && (
            <span className="text-4xl opacity-80 font-light">
              {minTemp}°{weatherData.temperatureUnit === "fahrenheit" ? "F" : "C"}
            </span>
          )}
        </p>
      </div>
    </div>
  );
};

export default WeatherCard;
